import React, { useEffect } from 'react'
import aos from "aos"
import 'aos/dist/aos.css'
import "../index.scss"


// Components imports
import Head from "../components/Head"
import Layout from "../components/Layout"
import Header from "../components/Header"
import HomePresentation from "../components/HomePresentation"
import Prestations from "../components/Prestations"


function App() {
  useEffect(() => { aos.init() }, [])

  return (
    <>
      <Head />
      <Layout>
        <Header />
        <HomePresentation />
        <Prestations />
      </Layout>
    </>
  )
}

export default App
